module.exports = __webpack_public_path__ + "static/media/eight.d7e9fcdc.ogg";